import React from 'react';
import styles from '../CheckoutPage.module.css';

interface CheckoutContainerProps {
  children: React.ReactNode;
  withMobileNav?: boolean;
}

const CheckoutContainer: React.FC<CheckoutContainerProps> = ({
  children,
  withMobileNav = true,
}) => (
  <div className={`${styles.page} ${withMobileNav ? styles.pageWithMobileNav : ''}`}>
    <div className={styles.container}>{children}</div>
  </div>
);

export default CheckoutContainer;
